import { PointsAccount } from '@rd/types';
import {
  PointsAccountActions,
  PointsAccountActionTypes,
} from '../actions/points-account.actions';

export interface PointsAccountState {
  pointsAccounts: PointsAccount[];
  error: boolean;
  loading: boolean;
}

const initialState: PointsAccountState = {
  loading: false,
  pointsAccounts: [],
  error: false,
};

export function pointsAccountReducer(
  state: PointsAccountState = initialState,
  action: PointsAccountActions,
): PointsAccountState {
  switch (action.type) {
    case PointsAccountActionTypes.LOAD_POINTS_ACCOUNTS: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case PointsAccountActionTypes.LOAD_POINTS_ACCOUNTS_SUCCESS: {
      return {
        ...state,
        pointsAccounts: [...action.payload],
        loading: false,
      };
    }
    case PointsAccountActionTypes.LOAD_POINTS_ACCOUNTS_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
